import React from 'react';
import { useState } from 'react';
import { Form, Input, Button, Icon, message } from 'antd';
import validator from 'validator';

import './PhotographerColumn.css';

const { TextArea } = Input;

export const PhotographerColumn = ({
  photographerName,
  sendUpdatedImageURL,
  getImagePreparedData,
  handlePhotoColumnEdit
}) => {
  const [photoUrlEditable, setPhotoUrlEditable] = useState(false);
  const [usageLinkInput, setUsageLinkInput] = useState('');
  const [imageLinkInput, setImageLinkInput] = useState('');

  const usageLink = photographerName && photographerName.usageUrl;
  const imageLink = photographerName && photographerName.imageUrl;

  const handleEdit = () => {
    setPhotoUrlEditable(true);
    handlePhotoColumnEdit(photographerName.id, true);
    setUsageLinkInput(usageLink);
    setImageLinkInput(imageLink);
  };

  const handleSaveUpdate = (e) => {
    e.preventDefault();
    const id = photographerName.id;

    try {
      if (
        usageLinkInput.trim() &&
        imageLinkInput.trim() &&
        validator.isURL(usageLinkInput) &&
        validator.isURL(imageLinkInput)
      ) {
        Promise.resolve(
          sendUpdatedImageURL({
            id,
            updatedImageUrl: imageLinkInput,
            updatedUsageUrl: usageLinkInput
          })
        ).then(() => {
          getImagePreparedData(id);
        });
        setPhotoUrlEditable(false);
        handlePhotoColumnEdit(photographerName.id, false);
      } else {
        message.error('Invalid values!');
      }
    } catch (err) {
      console.error(err);
    }
  };

  const copyToClipboard = (textToCopy) => {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(textToCopy);
    } else {
      let textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      return new Promise((res, rej) => {
        document.execCommand('copy') ? res() : rej();
        textArea.remove();
      });
    }
  };

  const handleCopy = () => {
    copyToClipboard(photographerName.usageUrl)
      .then(() => console.log('copied!'))
      .catch((e) => console.log('error: ', e));
  };

  const handleCancelUpdate = () => {
    setPhotoUrlEditable(false);
    handlePhotoColumnEdit(photographerName.id, false);
  };

  const usageLinkChangeHandler = (e) => {
    setUsageLinkInput(e.target.value);
  };

  const imageLinkChangeHandler = (e) => {
    setImageLinkInput(e.target.value);
  };

  const autoSize = (e) => {
    const el = e.target;
    setTimeout(() => {
      el.style.cssText = 'height:auto; padding:0';
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
    }, 0);
  };

  if (photographerName && !photoUrlEditable) {
    return (
      <div className='photographer-info'>
        <div className='usage-info'>
          <div className='usage-info_option'>
            <strong>Usage URL</strong>
            <Button className='edit-btn' type='button' onClick={handleEdit}>
              <Icon type='edit' />
              <span>Edit</span>
            </Button>
          </div>
          <a
            target='_blank'
            rel='nofollow noopener noreferrer'
            href={usageLink}
          >
            {usageLink}
          </a>
        </div>
        <div className='image-info'>
          <strong>Image URL</strong>
          <a
            target='_blank'
            rel='nofollow noopener noreferrer'
            href={imageLink}
          >
            {imageLink}
          </a>
        </div>
      </div>
    );
  }

  if (photographerName && photoUrlEditable) {
    return (
      <div className='photographer-info'>
        <Form onSubmit={handleSaveUpdate}>
          <div className='usage-info'>
            <div className='usage-info_option'>
              <strong>Usage URL</strong>
              <Form.Item>
                <Button
                  className='edit-btn'
                  type='button'
                  onClick={handleCancelUpdate}
                >
                  <Icon type='rollback' />
                  <span>Cancel</span>
                </Button>
              </Form.Item>
              <Form.Item>
                <Button className='edit-btn' type='button' onClick={handleCopy}>
                  <Icon type='copy' />
                  <span>Copy</span>
                </Button>
              </Form.Item>
              <Form.Item>
                <Button className='edit-btn' htmlType='submit'>
                  <Icon type='save' />
                  <span>Save</span>
                </Button>
              </Form.Item>
            </div>
            <Form.Item name='usageUrl' rules={[{ required: true }]}>
              <TextArea
                style={{ overflow: 'hidden' }}
                rows={2}
                onChange={usageLinkChangeHandler}
                value={usageLinkInput}
                onKeyDown={autoSize}
              ></TextArea>
            </Form.Item>
          </div>
          <div className='image-info'>
            <strong>Image URL</strong>
            <Form.Item name='imgUrl' rules={[{ required: true }]}>
              <TextArea
                style={{ overflow: 'hidden' }}
                rows={2}
                onChange={imageLinkChangeHandler}
                value={imageLinkInput}
                onKeyDown={autoSize}
              ></TextArea>
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }

  return '';
};
